<template>
  <div>

    <el-row :gutter="15">
      <el-col :span="12">
        <!--故障处理完成情况-->
        <el-card style="height: calc(50vh - 60px);">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>故障处理完成情况
          </div>

          <el-row>
            <div class="es-op-box">
              <el-date-picker style="float: left;width:250px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
                v-model="dateTimeFauDone" type="daterange" size="small" class="query" range-separator="至"
                start-placeholder="故障日期起始" end-placeholder="故障日期结束" @change="() => {

                  this.loadFauDoneList()
                }">
              </el-date-picker>

              <br />
            </div>
          </el-row>

          <el-row :gutter="5">
            <el-col :span="8">
              <div @click="() => { this.fauDoneVisible = true }" class="medal-div">

                <el-col :span="12">
                  <el-row class="medal-value">
                    <div style="margin-top: 25px;">
                      {{ doneRateFirst }}
                    </div>
                  </el-row>
                  <el-row class="medal-key">
                    完成率
                  </el-row>
                  <el-row class="medal-area">
                    {{ areaFirst }}
                  </el-row>
                </el-col>
                <el-col :span="12">

                  <el-image style="width: 100px; height: 120px;margin-left: -90px;"
                    :src="require('../imgs/goldmedal.png')">
                  </el-image>

                </el-col>
              </div>

            </el-col>
            <el-col :span="8">
              <div @click="() => { this.fauDoneVisible = true }" class="medal-div">

                <el-col :span="12">
                  <el-row class="medal-value">
                    <div style="margin-top: 25px;">
                      {{ doneRateSecond }}
                    </div>
                  </el-row>
                  <el-row class="medal-key">
                    完成率
                  </el-row>
                  <el-row class="medal-area">
                    {{ areaSecond }}
                  </el-row>
                </el-col>
                <el-col :span="12">

                  <el-image style="width: 100px; height: 120px;margin-left: -90px;"
                    :src="require('../imgs/silvermedal.png')">
                  </el-image>

                </el-col>
              </div>
            </el-col>

            <el-col :span="8">
              <div @click="() => { this.fauDoneVisible = true }" class="medal-div">

                <el-col :span="12">
                  <el-row class="medal-value">
                    <div style="margin-top: 25px;">
                      {{ doneRateThird }}
                    </div>
                  </el-row>
                  <el-row class="medal-key">
                    完成率
                  </el-row>
                  <el-row class="medal-area">
                    {{ areaThird }}
                  </el-row>
                </el-col>
                <el-col :span="12">

                  <el-image style="width: 100px; height: 120px;margin-left: -90px;"
                    :src="require('../imgs/bronzemedal.png')">
                  </el-image>

                </el-col>
              </div>
            </el-col>

          </el-row>

          <el-row :gutter="15">

            <el-col :span="6">

              <div @click="() => { this.fauDoneVisible = true }" class="tatistic-div">
                <el-row class="tatistic-value">
                  <div style="margin-top: 10px;">
                    {{ numFaultTotal == null ? 0 : numFaultTotal }}
                  </div>
                </el-row>
                <el-row class="tatistic-key">
                  故障总数
                </el-row>
              </div>

            </el-col>
            <el-col :span="6">

              <div @click="() => { this.fauDoneVisible = true }" class="tatistic-div">
                <el-row class="tatistic-value">
                  <div style="margin-top: 10px;">
                    {{ numFaultDone == null ? 0 : numFaultDone }}
                  </div>
                </el-row>
                <el-row class="tatistic-key">
                  处理完成数
                </el-row>
              </div>

            </el-col>
            <el-col :span="6">

              <div @click="() => { this.fauDoneVisible = true }" class="tatistic-div">
                <el-row class="tatistic-value">
                  <div style="margin-top: 10px;">
                    {{ numFaultDisDone == null ? 0 : numFaultDisDone }}
                  </div>
                </el-row>
                <el-row class="tatistic-key">
                  待处理数
                </el-row>
              </div>

            </el-col>
            <el-col :span="6">

              <div @click="() => { this.fauDoneVisible = true }" class="tatistic-div">
                <el-row class="tatistic-value">
                  <div style="margin-top: 10px;">
                    {{ numFaultDoneRate == null ? 0 : numFaultDoneRate }}
                  </div>
                </el-row>
                <el-row class="tatistic-key">
                  总完成率
                </el-row>
              </div>

            </el-col>

          </el-row>

        </el-card>
      </el-col>

      <el-col :span="12">
        <!--相同故障现象频繁度情况-->
        <el-card style="height: calc(50vh - 60px);">
          <div slot="header" class="card-header"><i
              class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>相同故障现象频繁度情况
          </div>
          <el-row>
            <div class="es-op-box">
              <el-date-picker style="float: left;width:250px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
                v-model="dateTimeFauAppe" type="daterange" size="small" class="query" range-separator="至"
                start-placeholder="故障日期起始" end-placeholder="故障日期结束" @change="() => {
                  this.queryObjFauAppe.pageNum = 1;
                  this.loadFauAppeList()
                }">
              </el-date-picker>
              <el-tag style="float: left;margin-bottom: 10px;">频度阈值</el-tag>
              <el-input v-model="queryObjFauAppe.fauNum" type='number' size="small" min="1" max="50"
                style="float: left;width: 70px;"
                @blur="() => { this.queryObjFauAppe.pageNum = 1; this.loadFauAppeList() }">

              </el-input>
              <br />
            </div>
          </el-row>

          <el-table :data="pageFauAppeData.list" ref="FauAppeTable" border stripe size="mini" height="calc(50vh - 200px)"
            v-loading="loadingFauAppe">
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="equiTypeName" label="设备类型">
            </el-table-column>
            <el-table-column prop="appeName" label="故障现象">
            </el-table-column>
            <el-table-column prop="fauNum" label="频度">
            </el-table-column>

          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageFauAppeData"
              @change="(cpage) => { this.queryObjFauAppe.pageNum = cpage; this.loadFauAppeList() }">
            </es-pagination>
          </div>

        </el-card>

      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <!--故障处理时长情况-->
        <el-card style="height: calc(50vh - 65px);margin-top: 10px;">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>故障处理时长情况
          </div>
          <el-row>
            <div class="es-op-box">
              <el-date-picker style="float: left;width:220px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
                v-model="dateTimeFauLength" type="daterange" size="small" class="query" range-separator="至"
                start-placeholder="故障日期起始" end-placeholder="故障日期结束" @change="() => {
                  this.loadFauLengthList()
                  this.loadFauLengthOverList()
                }">
              </el-date-picker>

              <br />
            </div>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="4">

              <el-row>
                <div @click="() => { this.fauLengthVisible = true }" class="tatistic-div">
                  <el-row class="tatistic-value">
                    <div style="margin-top: 10px;">
                      {{ numFauLengthTotal == null ? 0 : numFauLengthTotal.toFixed(2) }}
                    </div>
                  </el-row>
                  <el-row class="tatistic-key">
                    故障处理总时长
                  </el-row>
                </div>

              </el-row>

              <el-row>

                <div @click="() => { this.fauLengthVisible = true }" class="tatistic-div">
                  <el-row class="tatistic-value">
                    <div style="margin-top: 10px;">
                      
                    </div>{{ numFauLengthAva == null ? 0 : numFauLengthAva.toFixed(2) }}
                  </el-row>
                  <el-row class="tatistic-key">
                    故障处理平均时长
                  </el-row>
                </div>
              </el-row>

            </el-col>

            <el-col :span="8">

              <div id="divFauLength" style="height: 300px;width: 100%;">
              </div>

            </el-col>

            <el-col :span="4">

              <el-row>
                <div @click="() => { this.fauLengthOverVisible = true }" class="tatistic-div">
                  <el-row class="tatistic-value">
                    <div style="margin-top: 10px;">
                      {{ numFauLengthDone == null ? 0 : numFauLengthDone }}
                    </div>
                  </el-row>
                  <el-row class="tatistic-key">
                    故障处理完成数
                  </el-row>
                </div>

              </el-row>

              <el-row>

                <div @click="() => { this.fauLengthOverVisible = true }" class="tatistic-div">
                  <el-row class="tatistic-value">
                    <div style="margin-top: 10px;">
                      {{ numFauLengthOver == null ? 0 : numFauLengthOver }}
                    </div>
                  </el-row>
                  <el-row class="tatistic-key">
                    故障超时完成数
                  </el-row>
                </div>
              </el-row>

            </el-col>

            <el-col :span="8">

              <div id="divOverTime" style="height: 300px;width: 100%;">

              </div>

            </el-col>

          </el-row>

        </el-card>
      </el-col>

    </el-row>
    <!--各工区故障处理完成详情-->
    <el-dialog :visible.sync="fauDoneVisible" @closed="() => this.fauDoneVisible = false" width="1000px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>各工区故障处理完成详情
      </span>
      <el-form size="mini" label-position="right" label-width="150px" ref="fauDoneForm">

        <el-table :data="this.listFauDoneData" ref="fauDoneTable" border highlight-current-row stripe size="mini"
          height="50vh">

          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>

          <el-table-column prop="name" label="工区">
          </el-table-column>
          <el-table-column prop="fauAllNum" label="故障总数">
          </el-table-column>
          <el-table-column prop="fauDoneNum" label="处理完成数">
          </el-table-column>
          <el-table-column prop="fauDisDoneNum" label="待处理数">
          </el-table-column>
          <el-table-column prop="doneRate" label="完成率">
          </el-table-column>
        </el-table>

      </el-form>
    </el-dialog>
    <!--各工区故障处理时长详情-->
    <el-dialog :visible.sync="fauLengthVisible" @closed="() => this.fauLengthVisible = false" width="1000px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>各工区故障处理时长详情
      </span>
      <el-form size="mini" label-position="right" label-width="150px" ref="fauLengthForm">

        <el-table :data="this.listFauLengthData" ref="fauLengthTable" border highlight-current-row stripe size="mini"
          height="50vh">

          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>

          <el-table-column prop="name" label="工区">
          </el-table-column>
          <el-table-column prop="value" label="故障处理总时长">
          </el-table-column>
          <el-table-column prop="fauDoneNum" label="处理完成数">
          </el-table-column>
          <el-table-column prop="workFauHoursAva" label="故障处理平均时长">
          </el-table-column>

        </el-table>

      </el-form>
    </el-dialog>
    <!--各工区超时完成详情-->
    <el-dialog :visible.sync="fauLengthOverVisible" @closed="() => this.fauLengthOverVisible = false" width="1000px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>各工区超时完成详情
      </span>
      <el-form size="mini" label-position="right" label-width="150px" ref="fauLengthOverForm">

        <el-table :data="this.listFauLengthOverData" ref="fauLengthOverTable" border highlight-current-row stripe
          size="mini" height="50vh">

          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>

          <el-table-column prop="name" label="工区">
          </el-table-column>
          <el-table-column prop="fauDoneNum" label="处理完成数">
          </el-table-column>
          <el-table-column prop="fauOverTimeNum" label="超时完成数">
          </el-table-column>

        </el-table>

      </el-form>
    </el-dialog>

  </div>
</template>

<script>

import dateutils from '../../utils/dateutils.js'

export default {
  name: 'faultstatistic',
  data () {
    return {

      queryObjFauDone: {},//查询条件，设备故障频率 
      queryObjFauAppe: { pageNum: 1, pageSize: 20, fauNum: 1 },//查询条件     
      queryObjFauLength: {},//查询条件    

      pageFauAppeData: {},
      listFauDoneData: [],
      listFauLengthData: [],
      listFauLengthOverData: [],

      dateTimeFauDone: [],
      dateTimeFauAppe: [],
      dateTimeFauLength: [],

      loadingFauAppe: false,

      numFaultTotal: 0,//故障总数
      numFaultDone: 0,//处理完成数
      numFaultDisDone: 0,//待处理数
      numFaultDoneRate: 0,//总完成率

      numFauLengthTotal: 0,//故障处理总时长
      numFauLengthAva: 0,//故障处理平均时长
      numFauLengthDone: 0,//故障处理完成数
      numFauLengthOver: 0,//故障超时完成数

      fauLengthOverVisible: false,
      fauLengthVisible: false,
      fauDoneVisible: false,

      doneRateFirst: '0.00%',
      doneRateSecond: '0.00%',
      doneRateThird: '0.00%',
      areaFirst: 'xxxxx',
      areaSecond: 'xxxxx',
      areaThird: 'xxxxx',


    }
  },
  methods: {
    //页面初始化
    init () {
      this.dateTimeFauDone = [dateutils.dateFormat("YYYY-mm-01 00:00:00", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.dateTimeFauAppe = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.dateTimeFauLength = [dateutils.dateFormat("YYYY-mm-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]

      this.loadFauAppeList()//加载相同故障现象频繁度数据
      this.loadFauDoneList()//加载故障处理完成情况数据
      this.loadFauLengthList()//加载故障处理时长情况（故障处理时长）数据
      this.loadFauLengthOverList()//加载故障处理时长情况（故障处理超时）数据

    },


    //从后台查询相同故障现象频繁度数据
    loadFauAppeList () {

      if (this.dateTimeFauAppe != null && this.dateTimeFauAppe.length == 2) {
        this.queryObjFauAppe.starttime = this.dateTimeFauAppe[0]
        this.queryObjFauAppe.endtime = this.dateTimeFauAppe[1]
      }
      else {
        this.queryObjFauAppe.starttime = null
        this.queryObjFauAppe.endtime = null
      }

      this.loadingFauAppe = true
      this.$ajax.get('/buss/statisticfault/fauappelist', this.queryObjFauAppe).then((msg) => {

        this.pageFauAppeData = msg

        this.loadingFauAppe = false
      }).catch(err => {
        this.$message.error(err)
        this.loadingFauAppe = false
      })
    },

    //从后台查询加载故障处理完成情况数据
    loadFauDoneList () {

      if (this.dateTimeFauDone != null && this.dateTimeFauDone.length == 2) {
        this.queryObjFauDone.starttime = this.dateTimeFauDone[0]
        this.queryObjFauDone.endtime = this.dateTimeFauDone[1]
      }
      else {
        this.queryObjFauDone.starttime = null
        this.queryObjFauDone.endtime = null
      }

      this.$ajax.get('/buss/statisticfault/faudonelist', this.queryObjFauDone).then((msg) => {

        this.listFauDoneData = msg

      }).catch(err => {
        this.$message.error(err)

      })

      setTimeout(() => {//延迟，等待后台返回结果

        this.doneRateFirst = this.listFauDoneData[0].doneRate
        this.doneRateSecond = this.listFauDoneData[1].doneRate
        this.doneRateThird = this.listFauDoneData[2].doneRate
        this.areaFirst = this.listFauDoneData[0].name
        this.areaSecond = this.listFauDoneData[1].name
        this.areaThird = this.listFauDoneData[2].name

        this.numFaultTotal = 0
        this.numFaultDone = 0
        this.numFaultDisDone = 0
        this.numFaultDoneRate = '0.00%'
        for (let i = 0; i < this.listFauDoneData.length; i++) {

          this.numFaultTotal = this.numFaultTotal + this.listFauDoneData[i].fauAllNum//故障总数
          this.numFaultDone = this.numFaultDone + this.listFauDoneData[i].fauDoneNum//处理完成数
          this.numFaultDisDone = this.numFaultDisDone + this.listFauDoneData[i].fauDisDoneNum//待处理数

        }
        this.numFaultDoneRate = this.numFaultTotal==0?0.00+"%":Math.round(this.numFaultDone / this.numFaultTotal * 10000) / 100.00 + "%"//总完成率

      }, 1000);


    },

    //从后台查询故障处理时长情况（故障处理时长）数据
    loadFauLengthList () {


      if (this.dateTimeFauLength != null && this.dateTimeFauLength.length == 2) {
        this.queryObjFauLength.starttime = this.dateTimeFauLength[0]
        this.queryObjFauLength.endtime = this.dateTimeFauLength[1]
      }
      else {
        this.queryObjFauLength.starttime = null
        this.queryObjFauLength.endtime = null
      }

      this.$ajax.get('/buss/statisticfault/faulengthlist', this.queryObjFauLength).then((msg) => {

        this.listFauLengthData = msg

        this.initPieFauLength(this.listFauLengthData)

      }).catch(err => {
        this.$message.error(err)
      })

      setTimeout(() => {//延迟，等待后台返回结果
        this.numFauLengthTotal = 0
        this.numFauLengthAva = 0
        for (let i = 0; i < this.listFauLengthData.length; i++) {

          this.numFauLengthTotal = this.numFauLengthTotal + this.listFauLengthData[i].value
          this.numFauLengthAva = this.numFauLengthAva + this.listFauLengthData[i].fauDoneNum
        }
        this.numFauLengthAva = this.numFauLengthAva==0?0:this.numFauLengthTotal / this.numFauLengthAva

      }, 1000);


    },

    //从后台查询故障处理时长情况（故障处理超时）数据
    loadFauLengthOverList () {

      if (this.dateTimeFauLength != null && this.dateTimeFauLength.length == 2) {
        this.queryObjFauLength.starttime = this.dateTimeFauLength[0]
        this.queryObjFauLength.endtime = this.dateTimeFauLength[1]
      }
      else {
        this.queryObjFauLength.starttime = null
        this.queryObjFauLength.endtime = null
      }

      this.$ajax.get('/buss/statisticfault/faulengthoverlist', this.queryObjFauLength).then((msg) => {

        this.listFauLengthOverData = msg
        var dataKey = []
        var dataValue = []

        this.numFauLengthDone = 0
        this.numFauLengthOver = 0
        for (let i = 0; i < this.listFauLengthOverData.length; i++) {

          dataKey.push(this.listFauLengthOverData[i].name)
          dataValue.push(this.listFauLengthOverData[i].fauOverTimeNum)

          this.numFauLengthDone = this.numFauLengthDone + this.listFauLengthOverData[i].fauDoneNum
          this.numFauLengthOver = this.numFauLengthOver + this.listFauLengthOverData[i].fauOverTimeNum

        }

        this.initBarOverTime(dataKey, dataValue)

      }).catch(err => {
        this.$message.error(err)

      })
    },

    initPieFauLength (dateList) {
      let myChart = this.$echarts.init(document.getElementById('divFauLength'))
      var option = {
        color: ["#F86464", "#19DC7C", "#34A6FE", "#FA9022", "#DCDB01", "#8C70F8", "#2A4AD1", "#E76FE3", "#5032C0", "#168FB2"],
        title: {
          text: "各工区处理时长占比",
          x: '40%',
          y: '0%',

          textStyle: {
            color: '#040404',
            fontWeight: 'normal',
            fontSize: 16
          },

        },
        grid: {
          left: '2%',
          top: '1%',
          bottom: 10,
          right: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: 14
          },
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: '10%'
        },
        calculable: true,
        series: [
          {
            type: 'pie',
            radius: ["6%", "8%"],
            center: ['50%', '55%'],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            data: [{
              name: '',
              value: 0,
              itemStyle: {
                normal: {
                  color: "#68c5ff"
                }
              }
            }]
          },
          {
            type: 'pie',
            radius: ["69.5%", "70%"],
            center: ['50%', '55%'],
            hoverAnimation: false,
            labelLine: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false
              }
            },
            name: "",
            data: [{
              name: '',
              value: 0,
              itemStyle: {
                normal: {
                  color: "#0674bf"
                }
              }
            }]
          }, {
            stack: 'a',
            type: 'pie',
            radius: ['25%', '60%'],
            center: ['50%', '55%'],
            roseType: 'area',
            zlevel: 10,
            label: {
              normal: {
                formatter: '{d}%',
                borderWidth: 0,
                borderRadius: 4,
                padding: [0, -50],
                height: 40,
                fontSize: 12,
                align: 'center',
                rich: {
                  b: {
                    fontSize: 13,
                    lineHeight: 5,
                    color: '#41B3DC'
                  }
                }
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 20,
                length2: 55
              },
              emphasis: {
                show: false
              }
            },
            data: dateList
          },]
      };
      myChart.setOption(option)
    },

    initBarOverTime (dateKey, dateValue) {
      let myChart = this.$echarts.init(document.getElementById("divOverTime"))

      var option = {

        title: {
          text: '各工区超时完成数',
          textStyle: {
            color: '#040404',
            fontWeight: 'normal',
            fontSize: 16
          },

          padding: [0, 0, 0, 220]  // 位置
        },

        grid: {
          show: false,
          top: '10%',
          right: '4%',
          bottom: '18%',
          left: '8%'
        },
        xAxis: {
          type: 'category',
          data: dateKey,
          axisLabel: {
            showMaxLabel: true,
            interval: 0,
            rotate: 30,
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            barWidth: 20,
            type: 'bar',

            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = ["#F86464", "#19DC7C", "#34A6FE", "#FA9022", "#DCDB01", "#8C70F8", "#2A4AD1", "#E76FE3", "#5032C0", "#168FB2"]
                  return colorList[params.dataIndex]
                }
              }
            },
            data: dateValue

          }
        ]
      };
      myChart.setOption(option)

    },

  },

  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.tatistic-div {
  height: 85px;
  background: #c9e0f6;
  border-radius: 5px;
  margin-top: 45px;
  text-align: center;
}

.tatistic-value {
  color: rgb(68, 67, 67);
  margin-top: 3px;
  font-size: 24px;
}

.tatistic-key {
  color: rgb(14, 9, 9);
  margin-top: 10px;
  /* text-align: right; */
  font-size: 14px;
}


.medal-div {
  height: 120px;
  margin-top: 20px;
  border-radius: 5px;

  text-align: center;
}

.medal-value {
  color: rgb(68, 67, 67);
  margin-top: 0px;

  font-size: 18px;
}

.medal-key {
  color: rgb(14, 9, 9);
  margin-top: 5px;
  margin-right: 0px;
  /* text-align: right; */
  font-size: 12px;
}

.medal-area {
  color: rgb(14, 9, 9);
  margin-top: 5px;
  margin-right: 0px;
  /* text-align: right; */
  font-size: 14px;
}
</style>






